import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { configureApi } from './api/client';
import { App } from './app/App';
import { NotInTelegramScreen } from './screens/NotInTelegramScreen';
import { initSentry } from './sentry';
import { initTelegram } from './telegram/init';
import './index.css';

initSentry();
const env = initTelegram();
if (env) configureApi(env.rawInitData);

createRoot(document.getElementById('root')!).render(
  <StrictMode>{env ? <App env={env} /> : <NotInTelegramScreen />}</StrictMode>,
);
